<template>
  <div class="publicityPage">
    <van-loading size="24px" vertical v-if="showNonePage"
      >加载中...</van-loading
    >
    <div class="publicityBox" id="publicityBox" v-if="!showNonePage">
      <ul class="itemBox" v-if="this.listData.length > 0">
        <li v-for="item in listData" :key="item.id" class="itemList">
          <p class="itemHeader">
            <span>{{ item.realName }}</span>
            <span>{{ item.post }}</span>
          </p>
          <van-cell-group class="itemMain">
            <van-field
              :value="`${getGrigType(item.gridLevel)}`"
              readonly
              label="级别"
            />
            <van-field
              :value="`${item.position ? item.position : '/'}`"
              readonly
              label="职务"
            />
            <van-field
              :value="`${item.orgIdName ? item.orgIdName : '/'}`"
              readonly
              label="工作单位"
            />
            <van-field
              :value="`${item.jurisdictionName ? item.jurisdictionName : '/'}`"
              readonly
              label="管护范围"
            />
          </van-cell-group>
        </li>
      </ul>
      <div class="nonePage" v-if="this.listData.length < 1">
        <img :src="nonePng" alt />
        <p>暂无数据</p>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
// import { getToken } from "@/utils/common";
import nonePng from "@/assets/none.png";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "commonPublicity",
  data() {
    return {
      showNonePage: true,
      nonePng: nonePng, //默认图片
      baseUrl: process.env.BASE_URL,
      gridPoint: "", //链接传递的内点
      foestId: "",
      listData: [],
      clientType: "", //手机类型
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    this.clientType = getDeviceType();
    this.$nextTick(function () {
      if (this.dataInfo.objid && this.dataInfo.type) {
        this.initDutyPage();
      }
    });
  },
  methods: {
    initDutyPage() {
      //责任区电子公示牌
      let _this = this;
      _this.$api.universal.dutyArea
        .getAreaBoard(_this.dataInfo.type, _this.dataInfo.zqCode, {
          gridObjid: this.dataInfo.objid,
        })
        .then((res) => {
          if (res.code == "1") {
            _this.showNonePage = false;
            _this.listData = res.data;
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getGrigType(num) {
      let type = "";
      if (num == "1") {
        type = "省";
      } else if (num == "2") {
        type = "市";
      } else if (num == "3") {
        type = "县";
      } else if (num == "4") {
        type = "乡";
      } else {
        type = "村";
      }
      // console.log("num===="+num)
      // console.log("type===="+type)
      return type;
    },
    getPostName(text) {
      let name = "";
      if (text == "lz") {
        name = "林长";
      } else if (text == "flz") {
        name = "副林长";
      } else if (text == "ylyj") {
        name = "一林一技";
      } else if (text == "ylyjing") {
        name = "一林一警";
      } else if (text == "ylyy") {
        name = "一林一员";
      } else if (text == "xtdw") {
        name = "协同单位";
      } else if (text == "zlz") {
        name = "总林长";
      } else if (text == "fzlz") {
        name = "副总林长";
      }
      return name;
    },
  },
  watch: {
    dataInfo: {
      handler: function () {
        if (this.dataInfo.objid && this.dataInfo.type) {
          this.initDutyPage();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.publicityPage {
  width: 100%;
  height: 100%;
  .publicityBox {
    width: 100%;
    height: 100%;
    // padding: 8px 16px 50px;
    // overflow-y: scroll;
    background-color: #f6f6f6;
    position: relative;
    .itemBox {
      width: 100%;
      height: 100%;
      padding: 8px 16px 70px;
      overflow-y: scroll;
      .itemList {
        width: 100%;
        margin: 10px 0;
        overflow: hidden;

        .itemHeader {
          width: 100%;
          height: 60px;
          margin: 0 auto;
          background: url("~@/assets/img/publicityIconTop.png") no-repeat center;
          background-size: 100% 100%;
          position: relative;

          span {
            position: absolute;
          }

          span:first-child {
            font-size: 16px;
            color: #666;
            font-weight: 600;
            top: 50%;
            margin-top: -14px;
            left: 20px;
          }

          span:last-child {
            font-size: 18px;
            color: #4bc08a;
            font-weight: 600;
            top: 50%;
            margin-top: -14px;
            right: 20px;
          }
        }

        .itemMain {
          width: 100%;
          min-height: 97px;
          background: url("~@/assets/img/publicityIconMain.png") no-repeat
            center;
          background-size: 100% 100%;

          .van-cell {
            background: none;
            padding: 3px 16px;

            .van-field__label {
              color: #999;
              font-size: 14px;
            }

            .van-cell__value {
              .van-field__control {
                color: #999;
                font-size: 14px;
                text-align: right;
              }
            }
          }

          .van-cell:not(:last-child)::after {
            border: 0 none;
          }
        }

        .itemMain.van-hairline--top-bottom::after {
          border-width: 0 !important;
        }

        .itemMain.van-hairline::after {
          border: 0 none;
        }
      }
    }
    .nonePage {
      width: 120px;
      height: 150px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -75px;

      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
}
</style>